module.exports = __webpack_public_path__ + "static/media/19ESCAP26.9c94e4c4.jpg";